import Index from "../index";
import request from "@/common/request";
import { INewsDetails, IConmmen } from "./types.d";
import { IResponse } from "../types";
class IndexRequest extends Index {}

export default IndexRequest;
